module.exports = __webpack_public_path__ + "static/media/profile_background.ec4ebd2c.jpg";